import { render, staticRenderFns } from "./index.vue?vue&type=template&id=867b44fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=867b44fc&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=867b44fc&prod&lang=scss&scoped=true"
import style2 from "@/styles/pc.css?vue&type=style&index=2&id=867b44fc&prod&scoped=true&lang=css&external"
import style3 from "./index.vue?vue&type=style&index=3&id=867b44fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867b44fc",
  null
  
)

export default component.exports